function pdpStepsValidations() {
  // Get references to the form, inputs, and button
  const nameInput = document.getElementById("nameText");
  const editionSelect = document.getElementById("newspaper_book_edition");
  const nameError = document.querySelector(".name-input-error");
  const nameInput2 = document.getElementById("nameText2");
  const nameError2 = document.querySelector(".name2-input-error");
  const headingInput = document.getElementById("headingTextField");
  const headingError = document.querySelector(".heading-input-error");
  const surnameInput = document.getElementById("surnameText");
  const surnameError = document.querySelector(".surname-input-error");
  const surnameInput2 = document.getElementById("surnameText2");
  const surnameError2 = document.querySelector(".surname2-input-error");
  const textarea = document.getElementById("dedicationText");
  const dedicationError = document.querySelector(".dedication-input-error");
  const atcButton = document.querySelector(".atc-button"); // Select the button by name attribute
  const name_dedication_nullable = document.querySelector(
    'input[name="properties[customisation.name_dedication_nullable]"]',
  );
  const recipient_2_name_surname_nullable = document.querySelector(
    'input[name="properties[customisation.recipient_2_name_surname_nullable]"]',
  );
  const recipient_2_name_surname_nullable__label = document.querySelector(
    ".recipient_2_name_surname_nullable__label",
  );
  const ageInput = document.getElementById("ageOnCoverText");
  const ageError = document.querySelector(".ageOnCoverText-input-error");

  // Get references to the hidden date inputs (if they exist)
  const hiddenDayInput = document.getElementById("hidden-day");
  const hiddenMonthInput = document.getElementById("hidden-month");
  const hiddenYearInput = document.getElementById("hidden-year");
  const productSelector = document.querySelector("product-selector");
  const accordionBodyElement = document.querySelector(
    ".pdp-header__content .section-accordions__body",
  );

  // Remove existing event listeners to prevent duplicates
  if (editionSelect) {
    editionSelect.removeEventListener(
      "change",
      editionSelect._pdpChangeHandler,
    );
  }
  if (nameInput) {
    nameInput.removeEventListener("input", nameInput._pdpInputHandler);
    if (nameInput._pdpBlurHandler) {
      nameInput.removeEventListener("blur", nameInput._pdpBlurHandler);
    }
  }
  if (nameInput2) {
    nameInput2.removeEventListener("input", nameInput2._pdpInputHandler);
    if (nameInput2._pdpBlurHandler) {
      nameInput2.removeEventListener("blur", nameInput2._pdpBlurHandler);
    }
  }
  if (headingInput) {
    headingInput.removeEventListener("input", headingInput._pdpInputHandler);
    if (headingInput._pdpBlurHandler) {
      headingInput.removeEventListener("blur", headingInput._pdpBlurHandler);
    }
  }
  if (surnameInput) {
    surnameInput.removeEventListener("input", surnameInput._pdpInputHandler);
    if (surnameInput._pdpBlurHandler) {
      surnameInput.removeEventListener("blur", surnameInput._pdpBlurHandler);
    }
  }
  if (surnameInput2) {
    surnameInput2.removeEventListener("input", surnameInput2._pdpInputHandler);
    if (surnameInput2._pdpBlurHandler) {
      surnameInput2.removeEventListener("blur", surnameInput2._pdpBlurHandler);
    }
  }
  if (textarea) {
    textarea.removeEventListener("input", textarea._pdpInputHandler);
    if (textarea._pdpBlurHandler) {
      textarea.removeEventListener("blur", textarea._pdpBlurHandler);
    }
  }
  if (ageInput) {
    ageInput.removeEventListener("input", ageInput._pdpInputHandler);
  }
  if (name_dedication_nullable) {
    name_dedication_nullable.removeEventListener(
      "change",
      name_dedication_nullable._pdpChangeHandler,
    );
  }
  if (recipient_2_name_surname_nullable) {
    recipient_2_name_surname_nullable.removeEventListener(
      "change",
      recipient_2_name_surname_nullable._pdpChangeHandler,
    );
  }
  if (accordionBodyElement) {
    if (accordionBodyElement._pdpEditionLockClickHandler) {
      accordionBodyElement.removeEventListener(
        "click",
        accordionBodyElement._pdpEditionLockClickHandler,
        true,
      );
    }
    if (accordionBodyElement._pdpEditionLockKeydownHandler) {
      accordionBodyElement.removeEventListener(
        "keydown",
        accordionBodyElement._pdpEditionLockKeydownHandler,
        true,
      );
    }
  }

  // Function to show or hide error messages

  function validateInput(input, errorElement) {
    if (input.required && input.value.trim() === "") {
      errorElement.style.display = "block";
      return false;
    } else {
      errorElement.style.display = "none";
      return true;
    }
  }

  function getErrorElement(input, fallbackId) {
    if (!input) {
      return null;
    }

    const errorId =
      input.dataset && input.dataset.charErrorId
        ? input.dataset.charErrorId
        : fallbackId;

    if (!errorId) {
      return null;
    }

    const element = document.getElementById(errorId);
    return element || null;
  }

  /**
   * Safely decodes HTML entities from text.
   * Converts encoded entities like &amp; back to their character equivalents.
   * @param {string} text - Text containing HTML entities to decode
   * @returns {string} Decoded text
   */
  // Reuse a single decoder element for efficiency
  const _pdpDecoderElement =
    typeof document !== "undefined" && document.createElement
      ? document.createElement("textarea")
      : null;

  function decodeHTMLEntities(text) {
    if (!text || typeof text !== "string") {
      return "";
    }
    if (_pdpDecoderElement) {
      _pdpDecoderElement.innerHTML = text;
      return _pdpDecoderElement.value;
    }
    return text;
  }

  // Function to validate characters against allowlist
  // Cache for parsed allowlists: WeakMap<input, {raw: string, set: Set}>
  const _pdpAllowlistCache = new WeakMap();

  function getAllowedChars(input) {
    const rawAttr = input.dataset.allowedChars || "";
    const rawDecoded = decodeHTMLEntities(rawAttr);
    let cache = _pdpAllowlistCache.get(input);
    if (cache && cache.raw === rawDecoded) {
      return cache.set;
    }
    // Parse and cache
    let allowedChars = new Set();
    try {
      const chars = rawDecoded
        .trim()
        .split(",")
        .map((s) => {
          if (s === "") return ",";
          if (s === "\\n" || s === "\n") return "\n";
          if (s === "[") return "[";
          if (s === "]") return "]";
          if (s.length === 1) return s;
          return s.trim();
        })
        .filter((s) => s.length > 0);
      chars.forEach((char) => allowedChars.add(char));
    } catch (error) {
      console.warn(
        'Failed to parse allowed characters from "data-allowed-chars". Failing open with empty allowlist.',
        { allowedCharsRaw: input?.dataset?.allowedChars, error },
      );
      allowedChars = new Set();
    }
    _pdpAllowlistCache.set(input, { raw: rawDecoded, set: allowedChars });
    return allowedChars;
  }

  function validateCharacters(input, errorElement) {
    if (!input) return true;
    const value = input.value || "";

    // If field is readonly, disabled, or empty, treat as valid for char checks
    if (input.readOnly || input.disabled || value === "") {
      if (errorElement) errorElement.classList.add("hidden");
      input.dataset.invalidChars = "false";
      input.setAttribute("aria-invalid", "false");
      input.removeAttribute("aria-describedby");
      input.style.boxShadow = "";
      input.style.borderColor = "";
      return true;
    }

    // Use cached or parsed allowlist
    const hasConfiguredAllowlist = !!input.dataset.allowedChars?.trim();
    let allowedChars = hasConfiguredAllowlist
      ? getAllowedChars(input)
      : new Set();

    // Block repeated spaces and invisible Unicode whitespace characters.
    const invisibleUnicodePattern =
      /\u00A0|\u180E|\u2000|\u2001|\u2002|\u2003|\u2004|\u2005|\u2006|\u2007|\u2008|\u2009|\u200A|\u200B|\u200C|\u200D|\u202F|\u205F|\u2060|\u3000|\uFEFF/u;
    const multipleSpacePattern = / {2,}/;

    const hasDoubleSpaces = multipleSpacePattern.test(value);
    const hasInvisibleChars = invisibleUnicodePattern.test(value);

    // Check if all characters in value are in the allowed set
    let invalid = false;
    if (hasDoubleSpaces || hasInvisibleChars) {
      invalid = true;
    } else if (hasConfiguredAllowlist && allowedChars.size > 0) {
      for (let i = 0; i < value.length; i++) {
        const char = value[i];
        // Special handling for new line (\n) character
        if (char === "\n" && allowedChars.has("\n")) {
          continue;
        }
        if (!allowedChars.has(char)) {
          invalid = true;
          break;
        }
      }
    } else {
      // If no allowlist is configured (or allowlist is explicitly empty),
      // skip character restrictions and allow all characters through.
      invalid = false;
    }

    if (invalid) {
      if (errorElement) {
        const fieldTitle = input.dataset.fieldTitle
          ? decodeHTMLEntities(input.dataset.fieldTitle)
          : "";

        errorElement.textContent = fieldTitle
          ? `${fieldTitle} contains unsupported characters. Please remove special symbols or non-standard letters.`
          : "This field contains unsupported characters. Please remove special symbols or non-standard letters.";
        errorElement.classList.remove("hidden");

        if (errorElement.id) {
          input.setAttribute("aria-describedby", errorElement.id);
        }
      }
      input.dataset.invalidChars = "true";
      input.setAttribute("aria-invalid", "true");
      input.style.boxShadow = "0 0 0 2px rgba(238,21,86,0.15)";
      input.style.borderColor = "#EE1556";
      return false;
    } else {
      if (errorElement) errorElement.classList.add("hidden");
      input.dataset.invalidChars = "false";
      input.setAttribute("aria-invalid", "false");
      input.removeAttribute("aria-describedby");
      input.style.boxShadow = "";
      input.style.borderColor = "";
      return true;
    }
  }

  // Helper function to re-validate recipient 2 field characters
  function revalidateRecipient2Fields() {
    // Re-validate name2 characters when toggling optional/required
    if (nameInput2) {
      const nameCharError2 = getErrorElement(nameInput2, "name2-char-error");
      if (nameCharError2) {
        validateCharacters(nameInput2, nameCharError2);
      }
    }

    // Re-validate surname2 characters when toggling optional/required
    if (surnameInput2) {
      const surnameCharError2 = getErrorElement(
        surnameInput2,
        "surname2-char-error",
      );
      if (surnameCharError2) {
        validateCharacters(surnameInput2, surnameCharError2);
      }
    }
  }

  function isEditionSelectionPending() {
    return !!editionSelect && editionSelect.value === "";
  }

  function setPdpStepsLockState() {
    if (!accordionBodyElement || !editionSelect) return;

    const pdpSteps = accordionBodyElement.querySelectorAll(
      ".pdp-header-step.details",
    );
    const editionsStep = accordionBodyElement.querySelector(
      '.pdp_header__editions[data-pdp-header="editions"]',
    );

    function lockTrigger(trigger) {
      if (!trigger) return;

      if (!trigger.hasAttribute("data-pdp-original-tabindex")) {
        const originalTabIndex = trigger.getAttribute("tabindex");
        trigger.setAttribute(
          "data-pdp-original-tabindex",
          originalTabIndex === null ? "__none__" : originalTabIndex,
        );
      }

      trigger.setAttribute("aria-disabled", "true");
      trigger.setAttribute("tabindex", "-1");

      if (document.activeElement === trigger) {
        editionSelect.focus();
      }
    }

    function unlockTrigger(trigger) {
      if (!trigger) return;

      trigger.removeAttribute("aria-disabled");

      const originalTabIndex = trigger.getAttribute(
        "data-pdp-original-tabindex",
      );
      if (originalTabIndex === "__none__") {
        trigger.removeAttribute("tabindex");
      } else if (originalTabIndex !== null) {
        trigger.setAttribute("tabindex", originalTabIndex);
      }
      trigger.removeAttribute("data-pdp-original-tabindex");
    }

    if (isEditionSelectionPending()) {
      pdpSteps.forEach((step) => {
        const trigger = step.querySelector(':scope > div[role="button"]');
        if (step === editionsStep) {
          step.setAttribute("open", "");
          step.setAttribute("visited", "");
          unlockTrigger(trigger);
        } else {
          step.removeAttribute("open");
          step.removeAttribute("visited");
          lockTrigger(trigger);
        }
      });
      return;
    }

    pdpSteps.forEach((step) => {
      const trigger = step.querySelector(':scope > div[role="button"]');
      unlockTrigger(trigger);
    });

    if (editionsStep) {
      editionsStep.setAttribute("visited", "");
    }
  }

  function attachPdpStepsEditionLock() {
    if (!accordionBodyElement || !editionSelect) return;

    accordionBodyElement._pdpEditionLockClickHandler = function (event) {
      if (!isEditionSelectionPending()) return;

      const trigger = event.target.closest('.details > div[role="button"]');
      if (!trigger || !accordionBodyElement.contains(trigger)) return;

      event.preventDefault();
      event.stopPropagation();
      setPdpStepsLockState();
    };

    accordionBodyElement._pdpEditionLockKeydownHandler = function (event) {
      if (!isEditionSelectionPending()) return;

      const trigger = event.target.closest('.details > div[role="button"]');
      if (!trigger || !accordionBodyElement.contains(trigger)) return;

      const isToggleKey =
        event.key === "Enter" ||
        event.key === " " ||
        event.key === "Spacebar" ||
        event.keyCode === 13 ||
        event.keyCode === 32;

      if (!isToggleKey) return;

      event.preventDefault();
      event.stopPropagation();
      setPdpStepsLockState();
    };

    accordionBodyElement.addEventListener(
      "click",
      accordionBodyElement._pdpEditionLockClickHandler,
      true,
    );
    accordionBodyElement.addEventListener(
      "keydown",
      accordionBodyElement._pdpEditionLockKeydownHandler,
      true,
    );
  }

  // Function to enable or disable the button based on input content
  function toggleButtonState() {
    if (!atcButton) return;

    // Disable if edition select is present but no edition chosen yet
    if (editionSelect && editionSelect.value === "") {
      atcButton.disabled = true;
      return;
    }

    if (productSelector) {
      const fallbackVariant = productSelector.getVariantData?.()?.[0];
      let isAvailable = true;

      if (productSelector.currentVariant) {
        isAvailable = productSelector.currentVariant.available;
      } else if (fallbackVariant) {
        isAvailable = fallbackVariant.available;
      }

      if (!isAvailable) {
        atcButton.disabled = true;
        return;
      }
    }

    if (
      (nameInput && nameInput.required && nameInput.value.trim() === "") ||
      (nameInput2 && nameInput2.required && nameInput2.value.trim() === "") ||
      (headingInput &&
        headingInput.required &&
        headingInput.value.trim() === "") ||
      (surnameInput &&
        surnameInput.required &&
        surnameInput.value.trim() === "") ||
      (surnameInput2 &&
        surnameInput2.required &&
        surnameInput2.value.trim() === "") ||
      (textarea &&
        textarea.hasAttribute("required") &&
        textarea.value.trim() === "")
    ) {
      atcButton.disabled = true;
      return;
    }

    // Prevent proceeding when any field contains invalid characters
    const fieldsWithCharValidation = [
      textarea,
      nameInput,
      surnameInput,
      headingInput,
      nameInput2,
      surnameInput2,
    ];

    for (const field of fieldsWithCharValidation) {
      if (field && field.dataset.invalidChars === "true") {
        atcButton.disabled = true;
        return;
      }
    }

    if (hiddenDayInput && hiddenMonthInput && hiddenYearInput) {
      if (
        hiddenDayInput.value.trim() === "" ||
        hiddenMonthInput.value.trim() === "" ||
        hiddenYearInput.value.trim() === ""
      ) {
        atcButton.disabled = true;
        return;
      }
    }

    const accordionBody = document.querySelector(
      ".pdp-header__content .section-accordions__body",
    );

    // Only proceed if the accordion body exists
    if (accordionBody) {
      function checkAllVisited() {
        const detailsElements = accordionBody.querySelectorAll(".details");

        // Return false immediately if no details elements found
        if (detailsElements.length === 0) return true;

        for (let i = 0; i < detailsElements.length; i++) {
          if (!detailsElements[i].hasAttribute("visited")) {
            return false;
          }
        }
        return true;
      }

      const allSectionsVisited = checkAllVisited();
      atcButton.disabled = !allSectionsVisited;
      return;
    }

    atcButton.disabled = false;
  }

  // Character count and input validation for name input
  if (nameInput) {
    const charCountName = document.getElementById("charCountName");
    const maxLengthName = nameInput.getAttribute("maxlength");
    const nameCharError = getErrorElement(nameInput, "name-char-error");

    if (charCountName) {
      charCountName.textContent = `${nameInput.value.length}/${maxLengthName}`;
    }

    if (nameCharError) {
      validateCharacters(nameInput, nameCharError);
    }

    nameInput._pdpInputHandler = function () {
      if (charCountName) {
        charCountName.textContent = `${nameInput.value.length}/${maxLengthName}`;
      }
      if (nameError) validateInput(nameInput, nameError);
      if (nameCharError) {
        validateCharacters(nameInput, nameCharError);
      }
      toggleButtonState();
    };
    nameInput.addEventListener("input", nameInput._pdpInputHandler);

    // validate on blur as well
    nameInput._pdpBlurHandler = function () {
      if (nameCharError) {
        validateCharacters(nameInput, nameCharError);
      }
      if (nameError) validateInput(nameInput, nameError);
      toggleButtonState();
    };
    nameInput.addEventListener("blur", nameInput._pdpBlurHandler);
  }

  // Character count and input validation for heading input (mirrors name input)
  if (headingInput) {
    const charCountHeading = document.getElementById("charCountHeadingField");
    const maxLengthHeading = headingInput.getAttribute("maxlength");
    const headingCharError = getErrorElement(
      headingInput,
      "heading-char-error",
    );

    if (charCountHeading) {
      charCountHeading.textContent = `${headingInput.value.length}/${maxLengthHeading}`;
    }

    // Initial validation
    if (headingCharError) {
      validateCharacters(headingInput, headingCharError);
    }

    headingInput._pdpInputHandler = function () {
      if (charCountHeading) {
        charCountHeading.textContent = `${headingInput.value.length}/${maxLengthHeading}`;
      }
      if (headingError) validateInput(headingInput, headingError);
      if (headingCharError) {
        validateCharacters(headingInput, headingCharError);
      }
      toggleButtonState();
    };
    headingInput.addEventListener("input", headingInput._pdpInputHandler);

    // validate on blur as well
    headingInput._pdpBlurHandler = function () {
      if (headingCharError) {
        validateCharacters(headingInput, headingCharError);
      }
      if (headingError) validateInput(headingInput, headingError);
      toggleButtonState();
    };
    headingInput.addEventListener("blur", headingInput._pdpBlurHandler);
  }

  // Character count and input validation for surname input
  if (surnameInput) {
    const charCountSurname = document.getElementById("charCountSurname");
    const maxLengthSurname = surnameInput.getAttribute("maxlength");
    const surnameCharError = getErrorElement(
      surnameInput,
      "surname-char-error",
    );

    if (charCountSurname) {
      charCountSurname.textContent = `${surnameInput.value.length}/${maxLengthSurname}`;
    }

    // Initial validation
    if (surnameCharError) {
      validateCharacters(surnameInput, surnameCharError);
    }

    surnameInput._pdpInputHandler = function () {
      if (charCountSurname) {
        charCountSurname.textContent = `${surnameInput.value.length}/${maxLengthSurname}`;
      }
      if (surnameError) validateInput(surnameInput, surnameError);
      if (surnameCharError) {
        validateCharacters(surnameInput, surnameCharError);
      }
      toggleButtonState();
    };
    surnameInput.addEventListener("input", surnameInput._pdpInputHandler);

    // validate on blur as well
    surnameInput._pdpBlurHandler = function () {
      if (surnameCharError) {
        validateCharacters(surnameInput, surnameCharError);
      }
      if (surnameError) validateInput(surnameInput, surnameError);
      toggleButtonState();
    };
    surnameInput.addEventListener("blur", surnameInput._pdpBlurHandler);
  }

  // Character count and input validation for name input 2
  if (nameInput2) {
    const charCountName2 = document.getElementById("charCountName2");
    const maxLengthName2 = nameInput2.getAttribute("maxlength");
    const nameCharError2 = getErrorElement(nameInput2, "name2-char-error");

    if (charCountName2) {
      charCountName2.textContent = `${nameInput2.value.length}/${maxLengthName2}`;
    }

    // Initial validation
    if (nameCharError2) {
      validateCharacters(nameInput2, nameCharError2);
    }

    nameInput2._pdpInputHandler = function () {
      if (charCountName2) {
        charCountName2.textContent = `${nameInput2.value.length}/${maxLengthName2}`;
      }
      if (nameError2) validateInput(nameInput2, nameError2);
      if (nameCharError2) {
        validateCharacters(nameInput2, nameCharError2);
      }
      toggleButtonState();
    };
    nameInput2.addEventListener("input", nameInput2._pdpInputHandler);

    // validate on blur as well
    nameInput2._pdpBlurHandler = function () {
      if (nameCharError2) {
        validateCharacters(nameInput2, nameCharError2);
      }
      if (nameError2) validateInput(nameInput2, nameError2);
      toggleButtonState();
    };
    nameInput2.addEventListener("blur", nameInput2._pdpBlurHandler);
  }

  // Character count and input validation for surname input 2
  if (surnameInput2) {
    const charCountSurname2 = document.getElementById("charCountSurname2");
    const maxLengthSurname2 = surnameInput2.getAttribute("maxlength");
    const surnameCharError2 = getErrorElement(
      surnameInput2,
      "surname2-char-error",
    );

    if (charCountSurname2) {
      charCountSurname2.textContent = `${surnameInput2.value.length}/${maxLengthSurname2}`;
    }

    // Initial validation
    if (surnameCharError2) {
      validateCharacters(surnameInput2, surnameCharError2);
    }

    surnameInput2._pdpInputHandler = function () {
      if (charCountSurname2) {
        charCountSurname2.textContent = `${surnameInput2.value.length}/${maxLengthSurname2}`;
      }
      if (surnameError2) validateInput(surnameInput2, surnameError2);
      if (surnameCharError2) {
        validateCharacters(surnameInput2, surnameCharError2);
      }
      toggleButtonState();
    };
    surnameInput2.addEventListener("input", surnameInput2._pdpInputHandler);

    // validate on blur as well
    surnameInput2._pdpBlurHandler = function () {
      if (surnameCharError2) {
        validateCharacters(surnameInput2, surnameCharError2);
      }
      if (surnameError2) validateInput(surnameInput2, surnameError2);
      toggleButtonState();
    };
    surnameInput2.addEventListener("blur", surnameInput2._pdpBlurHandler);
  }

  function enforceLineLimit(textarea, maxLines) {
    if (!textarea) return 0;

    const lines = textarea.value.split("\n");
    if (lines.length > maxLines) {
      textarea.value = lines.slice(0, maxLines).join("\n");
    }
    return textarea.value.split("\n").length; // Return updated current line count
  }

  if (textarea) {
    const charCountDedication = document.getElementById("charCountDedication");
    const lineCountDedication = document.getElementById("lineCountDedication");
    const maxLengthDedication = textarea.getAttribute("maxlength");
    const maxLineLengthDedication =
      parseInt(textarea.getAttribute("maxLineLength")) || 0;
    const dedicationCharError = getErrorElement(
      textarea,
      "dedication-char-error",
    );

    if (charCountDedication) {
      charCountDedication.textContent = `${textarea.value.length}/${maxLengthDedication}`;
    }
    if (lineCountDedication) {
      lineCountDedication.textContent = `Lines: ${textarea.value.split("\n").length}/${maxLineLengthDedication}`;
    }

    // Initial character validation
    validateCharacters(textarea, dedicationCharError);

    textarea._pdpInputHandler = function () {
      const currentLines = enforceLineLimit(textarea, maxLineLengthDedication);

      if (charCountDedication) {
        charCountDedication.textContent = `${textarea.value.length}/${maxLengthDedication}`;
      }
      if (lineCountDedication) {
        lineCountDedication.textContent = `Lines: ${currentLines}/${maxLineLengthDedication}`;
      }

      if (dedicationError) validateInput(textarea, dedicationError);
      if (dedicationCharError) {
        validateCharacters(textarea, dedicationCharError);
      }
      toggleButtonState();
    };
    textarea.addEventListener("input", textarea._pdpInputHandler);

    // Validate on blur as well
    textarea._pdpBlurHandler = function () {
      if (dedicationCharError) {
        validateCharacters(textarea, dedicationCharError);
      }
      if (dedicationError) validateInput(textarea, dedicationError);
      toggleButtonState();
    };
    textarea.addEventListener("blur", textarea._pdpBlurHandler);
  }
  if (name_dedication_nullable) {
    // Store initial values if not already stored
    [
      nameInput,
      surnameInput,
      textarea,
      headingInput,
      nameInput2,
      surnameInput2,
      recipient_2_name_surname_nullable,
    ].forEach((field) => {
      if (field && !field.dataset.initialValue) {
        field.dataset.initialValue = field.value;
      }
    });
    name_dedication_nullable._pdpChangeHandler =
      function toggleRequiredFields() {
        const shouldBeOptional = name_dedication_nullable.checked;

        // Toggle required, disabled, and opacity for all fields
        [
          nameInput,
          surnameInput,
          textarea,
          headingInput,
          nameInput2,
          surnameInput2,
          recipient_2_name_surname_nullable,
          recipient_2_name_surname_nullable__label,
        ].forEach((field) => {
          if (field) {
            field.required = !shouldBeOptional;
            field.readOnly = shouldBeOptional;
            field.style.opacity = shouldBeOptional ? "0.2" : "1";
            field.style.pointerEvents = shouldBeOptional ? "none" : "auto";
            field.value = shouldBeOptional ? "" : field.dataset.initialValue;
            if (field.id === "headingTextField") {
              field.value = field.dataset.initialValue;
              field.required = false;
            }
            if (
              (field.id === "surnameText" || field.id === "surnameText2") &&
              field.dataset.hardRequired !== "true"
            ) {
              field.required = false;
            }
          }
        });

        // Re-validate dedication characters when toggling optional/required
        if (textarea) {
          const dedicationCharError = getErrorElement(
            textarea,
            "dedication-char-error",
          );
          if (dedicationCharError) {
            validateCharacters(textarea, dedicationCharError);
          }
        }

        // Re-validate surname characters when toggling optional/required
        if (surnameInput) {
          const surnameCharError = getErrorElement(
            surnameInput,
            "surname-char-error",
          );
          if (surnameCharError) {
            validateCharacters(surnameInput, surnameCharError);
          }
        }

        // Re-validate name characters when toggling optional/required
        if (nameInput) {
          const nameCharError = getErrorElement(nameInput, "name-char-error");
          if (nameCharError) {
            validateCharacters(nameInput, nameCharError);
          }
        }

        // Re-validate heading characters when toggling optional/required
        if (headingInput) {
          const headingCharError = getErrorElement(
            headingInput,
            "heading-char-error",
          );
          if (headingCharError) {
            validateCharacters(headingInput, headingCharError);
          }
        }

        // Re-validate name2 and surname2 characters when toggling optional/required
        revalidateRecipient2Fields();

        // If unchecking name_dedication_nullable and recipient_2_name_surname_nullable is checked,
        // apply the disabled state to nameInput2 and surnameInput2
        if (
          !shouldBeOptional &&
          recipient_2_name_surname_nullable &&
          recipient_2_name_surname_nullable.checked
        ) {
          [nameInput2, surnameInput2].forEach((field) => {
            if (field) {
              field.required = shouldBeOptional;
              field.readOnly = !shouldBeOptional;
              field.style.opacity = "0.2";
              field.style.pointerEvents = "none";
              field.value = shouldBeOptional ? "" : field.dataset.initialValue;
              if (
                field.id === "surnameText2" &&
                field.dataset.hardRequired !== "true"
              ) {
                field.required = false;
              }
            }
          });
        }
        // Find and close the parent .details element
        const parentDetails = name_dedication_nullable.closest(".details");
        if (parentDetails && shouldBeOptional) {
          parentDetails.removeAttribute("open");

          // Find and close the first previous sibling with .details class
          let prevSibling = parentDetails.previousElementSibling;
          while (prevSibling) {
            if (prevSibling.classList.contains("details")) {
              // Get the height of the previous sibling
              const prevSiblingRect = prevSibling.getBoundingClientRect();
              const scrollTop =
                window.pageYOffset || document.documentElement.scrollTop;
              prevSibling.removeAttribute("open");

              // Scroll to the top of the previous sibling
              if (window.innerWidth < 989.98) {
                window.scrollTo({
                  top: prevSiblingRect.top + scrollTop,
                  behavior: "smooth",
                });
              }
              break;
            }
            prevSibling = prevSibling.previousElementSibling;
          }

          let nextSibling = parentDetails.nextElementSibling;
          // Handle the special case where the cover accordion is not present, such as in the branded-logo-books template.
          if (nextSibling && nextSibling.classList.contains("details")) {
            nextSibling.setAttribute("open", "");
            nextSibling.setAttribute("visited", "");
          }
        }

        const openedStep = document.querySelector(".pdp-header-step[open]");
        if (openedStep && !openedStep.classList.contains("scrolled")) {
          openedStep.classList.add("scrolled");
        }

        toggleButtonState();
      };
    name_dedication_nullable.addEventListener(
      "change",
      name_dedication_nullable._pdpChangeHandler,
    );
    name_dedication_nullable._pdpChangeHandler();
  }
  if (recipient_2_name_surname_nullable) {
    // Store initial values if not already stored
    [nameInput2, surnameInput2].forEach((field) => {
      if (field && !field.dataset.initialValue) {
        field.dataset.initialValue = field.value;
      }
    });
    recipient_2_name_surname_nullable._pdpChangeHandler =
      function toggleRequiredFields() {
        const shouldBeOptional = recipient_2_name_surname_nullable.checked;

        // Toggle required, disabled, and opacity for recipient 2 fields
        [nameInput2, surnameInput2].forEach((field) => {
          if (field) {
            field.required = !shouldBeOptional;
            field.readOnly = shouldBeOptional;
            field.style.opacity = shouldBeOptional ? "0.2" : "1";
            field.style.pointerEvents = shouldBeOptional ? "none" : "auto";
            // Set value to '' if optional, otherwise restore initial value
            field.value = shouldBeOptional ? "" : field.dataset.initialValue;
            if (
              field.id === "surnameText2" &&
              field.dataset.hardRequired !== "true"
            ) {
              field.required = false;
            }
          }
        });

        // Re-validate name2 and surname2 characters when toggling optional/required
        revalidateRecipient2Fields();

        toggleButtonState();
      };
    recipient_2_name_surname_nullable.addEventListener(
      "change",
      recipient_2_name_surname_nullable._pdpChangeHandler,
    );
    recipient_2_name_surname_nullable._pdpChangeHandler();
  }
  // Character count and input validation for name input
  if (ageInput) {
    const charCountName = document.getElementById("charCountAgeOnCover");
    const maxLengthName = ageInput.getAttribute("maxlength");

    if (charCountName) {
      charCountName.textContent = `${ageInput.value.length}/${maxLengthName}`;
    }

    ageInput._pdpInputHandler = function () {
      this.value = this.value.replace(/[^0-9]/g, "");
      if (charCountName) {
        charCountName.textContent = `${ageInput.value.length}/${maxLengthName}`;
      }
      if (ageError) validateInput(ageInput, ageError);
      toggleButtonState();
    };
    ageInput.addEventListener("input", ageInput._pdpInputHandler);
  }
  if (editionSelect) {
    editionSelect._pdpChangeHandler = function () {
      setPdpStepsLockState();
      toggleButtonState();
    };
    editionSelect.addEventListener("change", editionSelect._pdpChangeHandler);
  }
  attachPdpStepsEditionLock();
  setPdpStepsLockState();
  // Initialize button state on page load
  toggleButtonState();
  window.toggleButtonState = toggleButtonState;

  if (!window._pdpPageshowHandler) {
    window._pdpPageshowHandler = function () {
      if (typeof window.toggleButtonState === "function") {
        window.toggleButtonState();
      }
    };
    window.addEventListener("pageshow", window._pdpPageshowHandler);
  }

  const pdpHeaderGiftStep = document.querySelector(
    '.pdp_header__gift[data-pdp-header="gift"]',
  );

  if (window._pdpGiftStepObserver) {
    window._pdpGiftStepObserver.disconnect();
    window._pdpGiftStepObserver = null;
  }

  if (pdpHeaderGiftStep && typeof MutationObserver !== "undefined") {
    window._pdpGiftStepObserver = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "open"
        ) {
          if (pdpHeaderGiftStep.hasAttribute("open")) {
            toggleButtonState();
          }
        }
      }
    });

    window._pdpGiftStepObserver.observe(pdpHeaderGiftStep, {
      attributes: true,
      attributeFilter: ["open"],
    });
  }
}
pdpStepsValidations();

document.addEventListener("product:reloaded", pdpStepsValidations);
